export default "__VITE_ASSET__CGWJ$Zid__"